import { __rest, __read, __spreadArray, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default, { useRef, useState, useMemo, useEffect } from 'react';
import classNames from './../../external_lib/classnames/index.js';
import pluralize from './../../external_lib/pluralize/pluralize.js';
import styles from '../../components/base/HorizonSelect/index.module.scss.js';
import HorizonInput from '../HorizonInput/index.js';
import Search from '../../assets/icons/jsx/Search.js';
import Cancel from '../../assets/icons/jsx/Cancel.js';
import ChevronDown from '../../assets/icons/jsx/ChevronDown.js';
import CheckMark from '../../assets/icons/jsx/CheckMark.js';
import BrandIcon from '../../components/helpers/brandIcon/brandIcon.js';
import { capitalize } from '../../utils/string.util.js';
import HorizonText from '../HorizonText/index.js';
import AntSelect from './../../external_lib/antd/es/select/index.js';
import Checkbox from './../../external_lib/antd/es/checkbox/index.js';
var sortSelectedToTop = function (a, b, selected) {
  if (a.key === 'all') return -1;
  if (b.key === 'all') return 1;
  if (selected.includes(a.key) && !selected.includes(b.key)) return -1;
  if (!selected.includes(a.key) && selected.includes(b.key)) return 1;
  return a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1;
};
function HorizonSelect(_a) {
  var _b = _a.field,
    field = _b === void 0 ? 'brand' : _b,
    _c = _a.options,
    options = _c === void 0 ? [] : _c,
    _d = _a.value,
    value = _d === void 0 ? [] : _d,
    _e = _a.triggerChangeOnClose,
    triggerChangeOnClose = _e === void 0 ? false : _e,
    _f = _a.allowClear,
    allowClear = _f === void 0 ? false : _f,
    onChange = _a.onChange,
    _g = _a.enableSearch,
    enableSearch = _g === void 0 ? false : _g,
    _h = _a.enableSelectAll,
    enableSelectAll = _h === void 0 ? false : _h,
    className = _a.className,
    popupClassName = _a.popupClassName,
    _j = _a.inputPlaceholder,
    inputPlaceholder = _j === void 0 ? 'Type to Search' : _j,
    mode = _a.mode,
    _k = _a.showLogoOnLabel,
    showLogoOnLabel = _k === void 0 ? false : _k,
    labelPrefix = _a.labelPrefix,
    _l = _a.loading,
    loading = _l === void 0 ? false : _l,
    restProps = __rest(_a, ["field", "options", "value", "triggerChangeOnClose", "allowClear", "onChange", "enableSearch", "enableSelectAll", "className", "popupClassName", "inputPlaceholder", "mode", "showLogoOnLabel", "labelPrefix", "loading"]);
  var ref = useRef(null);
  var inputRef = useRef(null);
  var _m = __read(useState(false), 2),
    open = _m[0],
    setOpen = _m[1];
  var _o = __read(useState(''), 2),
    searchVal = _o[0],
    setSearchVal = _o[1];
  var _p = __read(useState(Array.isArray(value) ? value.filter(function (v) {
      return v !== null && v !== undefined;
    }) : []), 2),
    selected = _p[0],
    setSelected = _p[1];
  var _q = __read(useState([]), 2),
    dropdownOptions = _q[0],
    setDropdownOptions = _q[1];
  var _r = __read(useState(false), 2),
    selectAll = _r[0],
    setSelectAll = _r[1];
  var allOptionsValues = useMemo(function () {
    return options.map(function (o) {
      return o.key;
    });
  }, [options]);
  var optionsList = useMemo(function () {
    return __spreadArray([], __read(options), false);
  }, [options]);
  useEffect(function () {
    setSelectAll(selected.length === allOptionsValues.length);
  }, [allOptionsValues, selected]);
  useEffect(function () {
    var filteredOptions = optionsList.filter(function (o) {
      var _a;
      return !searchVal.length || ((_a = o === null || o === void 0 ? void 0 : o.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchVal.toLowerCase()));
    }).sort(function (a, b) {
      return sortSelectedToTop(a, b, selected);
    });
    setDropdownOptions(filteredOptions);
  }, [searchVal, optionsList, selected]);
  var handleChange = function (val) {
    setSelected(val);
    if (!triggerChangeOnClose) onValueChange(val);
  };
  var onValueChange = function (val) {
    // If clear is not allowed and all options have been deselected
    // then set state to select all
    if (!allowClear && !val.length) {
      setSelected(__spreadArray([], __read(allOptionsValues), false));
      onChange === null || onChange === void 0 ? void 0 : onChange(allOptionsValues);
      return;
    }
    setSelected(val);
    onChange === null || onChange === void 0 ? void 0 : onChange(val);
  };
  var handleSelect = function (val, checked) {
    if (val === 'all' && mode) {
      var filteredKeys = optionsList.filter(function (o) {
        var _a;
        return (_a = o === null || o === void 0 ? void 0 : o.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchVal.toLowerCase());
      }).map(function (o) {
        return o.key;
      });
      var updatedSelection_1 = checked ? __spreadArray(__spreadArray([], __read(filteredKeys.filter(function (k) {
        return !selected.includes(k);
      })), false), __read(selected), false) : [];
      handleChange(updatedSelection_1);
      setSelectAll(!!checked);
      return;
    }
    var selectedOptions = selected.filter(function (o) {
      return o !== 'all';
    });
    var updatedSelection = checked ? mode ? __spreadArray(__spreadArray([], __read(selectedOptions), false), [val], false) : [val] : mode ? selectedOptions.filter(function (o) {
      return o !== val;
    }) : selectedOptions;
    handleChange(updatedSelection);
    if (!mode && checked) {
      setOpen(false);
    }
  };
  var handleClear = function () {
    setSelectAll(false);
    handleChange([]);
  };
  var renderSelectedText = function (props) {
    var tagValue = props.value;
    var optionIndex = selected.findIndex(function (o) {
      return o === tagValue;
    });
    if (optionIndex !== 0 || loading || optionsList.length <= 0) return React__default.createElement(React__default.Fragment, null);
    var selectedValue = optionsList.find(function (o) {
      return selected.includes(o.key);
    });
    if (!mode && selectedValue) {
      return React__default.createElement("div", {
        className: "flex items-center gap-x-2"
      }, showLogoOnLabel && React__default.createElement(BrandIcon, {
        brand: {
          logo: selectedValue.logo,
          name: selectedValue.label
        }
      }), labelPrefix, React__default.createElement("div", {
        className: "text-up-black-100 font-semibold"
      }, capitalize(selectedValue.label)));
    }
    return React__default.createElement("div", {
      className: "text-up-black-100 font-semibold"
    }, "".concat(selected.length, " ").concat(pluralize(field, selected.length), " selected"));
  };
  var onDropdownVisibleChange = function (isVisible) {
    var _a;
    setOpen(isVisible);
    if (isVisible) {
      // Focus search input when dropdown opened
      setTimeout(function () {
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
          inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.focus();
        }
      }, 500);
    }
    if (triggerChangeOnClose) onValueChange(selected);
    var sortedOptions = optionsList.sort(function (a, b) {
      return sortSelectedToTop(a, b, selected);
    });
    setDropdownOptions(sortedOptions);
    setSearchVal('');
    if (ref.current) {
      // Reset option list scroll to the top
      (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
        index: 0
      });
    }
  };
  var dropdownRender = function (menu) {
    if (loading) {
      return React__default.createElement("div", {
        className: "px-3 py-2 text-up-black-40"
      }, "Loading...");
    }
    return React__default.createElement(React__default.Fragment, null, (enableSearch || optionsList.length >= 5) && React__default.createElement("div", {
      className: styles.horizonSelectInput
    }, React__default.createElement(HorizonInput, {
      allowClear: allowClear,
      prefix: React__default.createElement(Search, {
        className: "text-up-black-40"
      }),
      ref: inputRef,
      variant: "borderless",
      value: searchVal,
      placeholder: inputPlaceholder,
      onChange: function (e) {
        var _a;
        return setSearchVal((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
      },
      onKeyDown: function (e) {
        return e.stopPropagation();
      }
    })), enableSelectAll && dropdownOptions.length > 0 && React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
      className: classNames(styles.horizonSelectInput, 'flex justify-between items-center px-3 py-2')
    }, React__default.createElement("div", null, "".concat(selected.length, " ").concat(pluralize(field, selected.length), " selected")), allowClear && React__default.createElement(HorizonText, {
      onClick: handleClear,
      className: classNames('font-semibold text-up-blue-40', !selected.length ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer')
    }, "Clear all")), React__default.createElement("div", {
      className: classNames(styles.horizonSelectInput, 'px-3 py-2')
    }, React__default.createElement("span", {
      className: "mr-1.5"
    }, React__default.createElement(Checkbox, {
      checked: selectAll,
      onChange: function (e) {
        return handleSelect('all', e.target.checked);
      }
    })), "Select all ", pluralize(field))), React__default.createElement("div", null, menu));
  };
  return React__default.createElement(AntSelect, __assign({
    open: open,
    ref: ref,
    rootClassName: classNames(styles.horizonSelect, className),
    popupClassName: classNames(popupClassName, 'p-0'),
    suffixIcon: React__default.createElement(ChevronDown, {
      className: classNames(open && 'text-up-blue-40', 'transition-transform origin-center'),
      style: {
        transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
      }
    }),
    allowClear: allowClear && mode !== 'multiple' && {
      clearIcon: React__default.createElement(Cancel, null)
    },
    menuItemSelectedIcon: function () {
      return null;
    },
    mode: "multiple",
    showSearch: false,
    onSelect: function (val) {
      return handleSelect(val, true);
    },
    onDeselect: function (val) {
      return handleSelect(val, false);
    },
    value: selected,
    tagRender: renderSelectedText,
    dropdownRender: dropdownRender,
    onDropdownVisibleChange: onDropdownVisibleChange,
    onClear: handleClear
  }, restProps), dropdownOptions.map(function (o) {
    return React__default.createElement(AntSelect.Option, {
      key: o.key,
      value: o.value,
      className: classNames(mode && styles.horizonSelectOption)
    }, React__default.createElement("div", {
      className: "flex items-center justify-between"
    }, React__default.createElement("div", {
      className: "flex items-center gap-x-2"
    }, !mode && showLogoOnLabel && React__default.createElement("span", {
      className: "w-6 h-6"
    }, React__default.createElement(BrandIcon, {
      brand: {
        logo: o.logo,
        name: o.label
      }
    })), React__default.createElement("div", null, mode && React__default.createElement("span", {
      className: "mr-1.5"
    }, React__default.createElement(Checkbox, {
      checked: selected.includes(o.key)
    })), React__default.createElement("span", null, capitalize(o.label)))), !mode && selected.includes(o.key) ? React__default.createElement(CheckMark, {
      className: "text-up-blue-40 w-4 h-4"
    }) : mode && showLogoOnLabel ? React__default.createElement("span", {
      className: "w-6 h-6"
    }, React__default.createElement(BrandIcon, {
      brand: {
        logo: o.logo,
        name: o.label
      }
    })) : null));
  }));
}
export { HorizonSelect as default };
//# sourceMappingURL=index.js.map
